<template>
  <div id="threads" v-if="loaded">
      <h3>הודעות אחרונות</h3>
      <ul class="list" v-if="list.length > 0">
          <li :class="(activeItem == item.uid ? 'active' : '')" v-for="item in list" :key="item" @click="goto_inbox()">
              <UserIcon size="sml" :user_data="item.user_data" :clickable="false" />
              <span class="name" v-text="item.user_data.display_name"></span>
              <span class="msg" v-text="item.msg"></span>
            </li>
      </ul>
      <div v-else>
          <h3>אין שיחות פעילות...</h3>
      </div>
  </div>
</template>

<script>

import UserIcon from '../user_icon.vue';
export default {
    components: { UserIcon },
    data(){
        return {
            list: [],
            loaded:false,
            activeItem: ''
        }
    },
  methods: {
    goto_inbox(){
        this.$router.push('/inbox');
    }
      

  },
  mounted(){
      
      var self = this;
      // categories 
      this.api({ action: 'chat/get_threads', data: { } }, function(data){ 
          
          self.list = data.data.list;
          self.loaded = true;
       
      });
  }
}
</script>

<style lang="scss" scoped>
#threads {
    &{    background: rgba(0, 0, 0, 0.72); color: #fff;padding: 18px 14.7px 36px 14.3px; border-radius: 10px;box-shadow: -22px 0 20px -20px rgba(0, 0, 0, 0.72);}
    .list { 
        li { display: block; cursor: pointer; overflow: hidden; padding: 15px;
            &.active { background: #1e212a; }
            .user_icon  { float:right; margin-left:10px; }
            .name { display: block;}
            .msg { display: block; font-size: 13px; color: #999;}
        }
    }
}

</style>